import React from "react";
import { Snowflake, Leaf, Droplets, Sun, Hand, MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { PRE_HARVEST_MODE } from "@/lib/siteMode";

const ICONS = [Leaf, Snowflake, Droplets, Hand, MapPin, Sun];

export default function Benefits() {
  const { t } = useLang();
  const items = t("benefits.items");

  return (
    <section
      id="calidad"
      data-testid="benefits-section"
      className="relative bg-cream-200 py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16 lg:mb-20">
          <div className="lg:col-span-7">
            <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
              {t("benefits.overline")}
            </span>
            <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-olive-900 font-medium">
              {t("benefits.h2_a")} <br />
              {t("benefits.h2_b")} <span className="italic">{t("benefits.h2_c")}</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-8">
            <p className="text-base sm:text-lg leading-relaxed text-olive-800/80 font-light">
              {t("benefits.intro")}
            </p>
            {PRE_HARVEST_MODE && (
              <p
                data-testid="benefits-reference-note"
                className="mt-4 text-xs text-olive-800/55 border-l-2 border-gold-deep pl-3 italic"
              >
                {t("pre_harvest.reference_note")}
              </p>
            )}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-olive-700/20">
          {items.map((b, i) => {
            const Icon = ICONS[i] || Leaf;
            return (
              <div
                key={b.title}
                data-testid={`benefit-card-${i}`}
                className="p-8 lg:p-10 border-b border-olive-700/20 md:[&:nth-child(2n)]:border-l lg:[&:nth-child(3n-1)]:border-l lg:[&:nth-child(3n)]:border-l border-olive-700/20 transition-colors duration-300 hover:bg-cream-100"
              >
                <Icon size={28} strokeWidth={1.1} className="text-gold-deep" />
                <h3 className="mt-8 font-serif text-2xl text-olive-900">{b.title}</h3>
                <p className="mt-3 text-olive-800/75 font-light leading-relaxed">
                  {b.desc}
                </p>
                <div className="mt-8 text-[10px] uppercase tracking-[0.3em] text-olive-800/40">
                  0{i + 1} / 06
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
